import { DETAIL_TABS } from "./detailLayout";
import { CRITICAL_HITOS } from "./hitosModel";

// Bloques de columnas de la hoja: las mismas categorías que la ficha de la obra
// (detailLayout.js), para que hoja y ficha hablen igual. Todas se sombrean:
// - Las de la pestaña General (identificación, planificación, equipo, operativa y notas)
//   llevan el tono 0, un gris muy claro: son los datos principales de la obra.
// - Las demás (hitos y entregables, costes / CAPEX) alternan gris claro (1) y gris medio
//   (2), empezando por el claro, para ver dónde acaba una y empieza la siguiente.
// Van en el orden en que la hoja trae las columnas por defecto. Una categoría nueva de la
// ficha que no esté aquí queda sin sombrear (lo avisa su test).
const SECTION_ORDER = [
    "identificacion", "planificacion", "valoracion", "equipo",
    "imagen", "mob", "ilum", "suelos",
    "oc", "bsk", "otros", "control",
    "notas", "operativa", "tecnologia",
];
const MAIN_TAB = "general";

const DETAIL_SECTIONS = new Map(DETAIL_TABS.flatMap((tab) => tab.sections.map((section) => [section.id, { ...section, tab: tab.id }])));

let alternating = 0;
export const SHEET_BLOCKS = SECTION_ORDER.map((id) => {
    const section = DETAIL_SECTIONS.get(id);
    const main = section?.tab === MAIN_TAB;
    const tone = main ? 0 : (alternating++ % 2) + 1;
    return { id, tone, label: section?.label || id, fields: section?.fields || [] };
});

const BLOCK_BY_FIELD = new Map(SHEET_BLOCKS.flatMap((block) => block.fields.map((field) => [field, block])));

// Columnas de la hoja cuyo id no es el de un campo de la obra, con el campo del que salen.
// Los indicadores calculados llevan el tono del dato con el que se calculan:
// - Desviación CAPEX = total inversión − CAPEX aprobado, y EUR/m2 = €/m² de la inversión.
// - Alertas = las de los hitos críticos (zonificación, legal, planos P3, deadline MOB).
const COLUMN_FIELDS = {
    codigo: "codigoTienda",
    margen: "totalInversion",
    eurom2: "euroM2Inv",
    bloq: CRITICAL_HITOS[0].field,
};

// Categoría de una columna de la hoja, o null si no tiene dato de la ficha detrás (casilla,
// número de fila, acciones).
export const sheetBlockOf = (columnId) => BLOCK_BY_FIELD.get(COLUMN_FIELDS[columnId] || columnId) || null;

// Clase del tono de su categoría para la cabecera y las celdas de una columna ("" si no
// tiene categoría).
export const sheetBlockClass = (columnId) => {
    const block = sheetBlockOf(columnId);
    return block ? `obras-block--tone-${block.tone}` : "";
};
